<style scoped lang="scss" type="text/scss">
    .group-photo-container {
        .uploader {
            height: 30rem;
        }

        .submit-buttons {
            margin-top: 1rem;
        }

        .sample-photo {
            margin-top: .5rem;
        }
    }
</style>

<template>
    <div class="group-photo-container">
        <block-divider>合照</block-divider>

        <i-single-image-uploader
                class="uploader full-width"
                ref="groupPhotoImageUploader"
                v-model="uploadImage"
                :limit-types="['.png', '.jpg', '.svg', '.jpeg']"
                :limit-size="2 * 1024 * 1024"
                :src="src"
                title="合照"
                reversed
                @file-uploaded="fileUploaded"
        >
            <div class="extra-info">
                <info-panel class="info-panel" size="small">
                    图片类型：JPG / SVG / PNG / JPEG
                </info-panel>
                <info-panel class="info-panel" size="small">
                    大小限制：2 MB 以下
                </info-panel>
                <info-panel class="info-panel" size="small">
                    尺寸建议：1366 像素 * 768 像素
                </info-panel>
            </div>
        </i-single-image-uploader>
        <div>
            <sample-photo class="sample-photo"
                          src="//robo-static.oss-cn-qingdao.aliyuncs.com/images/normal-placeholder.png"
                          title="合照" tip="合照请包涵校旗、队旗、参赛队标语等元素">
            </sample-photo>
        </div>
    </div>
</template>

<script>
    import BlockDivider from '../../../../../components/divider/block';
    import ISingleImageUploader from '../../../../../components/i-uploader/single-image-uploader';
    import InfoPanel from '../../../../../components/info-panel/index';
    import _ from 'lodash';
    import SamplePhoto from '../../../../../components/sample-photo/index';

    export default {
        name: '',
        components: {
            BlockDivider,
            InfoPanel,
            ISingleImageUploader,
            SamplePhoto
        },
        data () {
            return {
                uploadImage: {}
            };
        },
        computed: {
            currentManagedPlayerId () {
                return this.$store.state.player.currentManagedPlayerId;
            },
            currentManagedPlayerInfo () {
                return this.$store.state.player.currentManagedPlayerInfo;
            },
            src () {
                return _.get(this.currentManagedPlayerInfo, 'group_photo.url', null);
            }
        },
        watch: {
            currentManagedPlayerInfo: {
                immediate: true,
                handler (info) {
                    this.introduce = info.introduce;
                }
            }
        },
        methods: {
            fileUploaded (fileInfo, _, throwFail) {
                // console.log(fileInfo)
                // console.log(throwFail)
                this.$normalRequest('player/updateGroupPhoto', {
                    id: this.currentManagedPlayerId,
                    ...fileInfo
                }, '合照更新成功').then(_ => {
                    this.$store.dispatch('player/loadRegistrableManagedPlayerInfo').then();
                    fileInfo.finish_callback();
                }).catch(_ => {
                    throwFail();
                    fileInfo.finish_callback();
                });
            }
        }
    };
</script>
